var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEyeCard = function SvgIconEyeCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M8 11.383a2.888 2.888 0 0 1 0-5.774 2.888 2.888 0 0 1 0 5.774Zm0-4.774a1.89 1.89 0 0 0-1.886 1.887A1.89 1.89 0 0 0 8 10.383a1.89 1.89 0 0 0 1.887-1.887A1.89 1.89 0 0 0 8 6.609Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M8 14.511c-2.506 0-4.873-1.467-6.5-4.013-.706-1.1-.706-2.894 0-4C3.134 3.95 5.5 2.484 8 2.484s4.867 1.467 6.493 4.014c.707 1.1.707 2.893 0 4C12.867 13.044 10.5 14.51 8 14.51ZM8 3.484c-2.153 0-4.213 1.294-5.653 3.554-.5.78-.5 2.14 0 2.92 1.44 2.26 3.5 3.553 5.653 3.553 2.153 0 4.213-1.293 5.653-3.553.5-.78.5-2.14 0-2.92-1.44-2.26-3.5-3.554-5.653-3.554Z"
  })));
};
export default SvgIconEyeCard;